import { makeStyles, Typography, IconButton, Tooltip } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

import { borderColor } from 'src/data/colors';

type PointsUIProps = {
  title: string;
  description?: string;
  unit?: string;
  readOnly?: boolean;
  children: React.ReactNode;
};

const useStyles = makeStyles({
  container: {
    backgroundColor: 'white',
    border: `1px solid ${borderColor}`,
    borderRadius: 8,
    padding: 16,
    height: '100%',
    cursor: (props: { readOnly?: boolean }) => (props.readOnly ? 'not-allowed' : 'auto'),
    '& *': {
      cursor: (props: { readOnly?: boolean }) => (props.readOnly ? 'not-allowed' : 'auto'),
    },
  },
  labelTitle: {
    position: 'relative',
    fontSize: 18,
    flex: 1,
  },
  infoContainer: {
    borderBottom: `1px solid ${borderColor}`,
    padding: '0 0 16px',
    marginBottom: 8,
  },
  description: {
    fontSize: 14,
  },
  tag: {
    fontSize: 9,
    textTransform: 'uppercase',
    position: 'absolute',
    left: 1,
    top: 23,
  },
  unit: {
    fontSize: 14,
    marginTop: -8,
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8,
  },
  infoIcon: {
    padding: 0,
    marginTop: 4,
    '& svg': {
      fontSize: 20,
    },
  },
  tooltip: {
    fontSize: 12,
  },
});

const PointsUI: React.FC<PointsUIProps> = ({ title, description, unit, readOnly, children }) => {
  const classes = useStyles({ readOnly });

  return (
    <div className={classes.container}>
      <div className={classes.infoContainer}>
        <div className={classes.titleContainer}>
          <Typography className={classes.labelTitle}>
            {title}
            {readOnly && (
              <Typography component="span" className={classes.tag}>
                read only
              </Typography>
            )}
          </Typography>

          {description && (
            <Tooltip title={description} placement="top" classes={{ tooltip: classes.tooltip }}>
              <IconButton className={classes.infoIcon}>
                <InfoOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}
        </div>
      </div>
      {children}
    </div>
  );
};

export default PointsUI;
